module.exports = __webpack_public_path__ + "img/ssyx_05.e84e4f5c.jpg";